import DepositSurvey from "../DepositSurvey/DepositSurvey";
import { Modal } from "react-bootstrap";

function DepositSurveyModal(props) {
    const {handleCloseSurvey} = props;

    return <>
        <Modal.Header closeButton/>
        <DepositSurvey handleCloseSurvey={handleCloseSurvey}/>
    </>
}

export default DepositSurveyModal;
